import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  FormHelperText,
  Grid,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  changeEmailAndPassword,
  checkUser,
  getData,
} from "../../../Config/FirebaseMethod";

const Security = () => {
  const [isloading, setIsloading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [stdData, setStdData] = useState({});
  const [msg, setMsg] = useState("");
  const [email, setEmail] = useState("");
  const [Newpassword, setPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");

  const { id, password } = stdData;

  const currentStdData = () => {
    checkUser()
      .then((res) => {
        return getData(`AneeqUllahKhan/`, res)
          .then((success) => {
            setStdData(success);
            setIsloading(false);
          })
          .catch((err) => {
            // Handle error
          });
      })
      .catch((err) => {
        // Handle error
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    changeEmailAndPassword(id, oldPassword, email, Newpassword)
      .then(() => {
        setMsg("Password and email changed successfully");
        setLoading(false);
      })
      .catch((error) => {
        setMsg(`Error changing password and email: ${error}`);
        setLoading(false);
      });
  };

  useEffect(() => {
    currentStdData();
  }, []);

  return (
    <>
      {isloading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "80vh",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Card
                sx={{
                  minWidth: 32 + "%",
                  borderRadius: 3,
                }}
              >
                <CardContent>
                  <h4 className="text-center mt-3 mb-4">
                    Privacy & Security Settings
                  </h4>
                  <p className="text-center">
                    If You Want To Change Your Email And Password You Can Use
                    Fill The Form Below
                  </p>

                  <Divider />

                  <div className="container mt-5 mb-5">
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                              <label className="form-label">
                                Email Address
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                name="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                              />
                            </div>
                            <div className="mb-3">
                              <label className="form-label">Old Password</label>
                              <input
                                type="password"
                                className="form-control"
                                name="oldPassword"
                                required
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                              />
                            </div>
                            <div className="mb-4">
                              <label className="form-label">Password</label>
                              <input
                                type="password"
                                className="form-control"
                                name="password"
                                required
                                value={Newpassword}
                                onChange={(e) => setPassword(e.target.value)}
                              />
                            </div>
                            <Button
                              variant="contained"
                              type="submit"
                              color="success"
                            >
                              {loading ? <CircularProgress /> : "Submit"}
                            </Button>
                          </form>
                        </div>

                        <div className="mt-3">
                          <FormHelperText
                            id="component-error-text"
                            sx={{ color: "green", fontSize: 16 }}
                          >
                            {msg}
                          </FormHelperText>
                        </div>
                      </div>
                      <div className="col-lg-6"></div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};

export default Security;
